import * as React from 'react';
import { SVGProps } from 'react';

const IconVideoSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3l4.553 2.276A1 1 0 0 0 26 18.382V9.618a1 1 0 0 0-1.447-.894L20 11V8a2 2 0 0 0-2-2H4Z" />
  </svg>
);
export default IconVideoSizeL;
